// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"292":"3343466e","348":"a110c460","787":"d41e5ad9"}[chunkId] + ".chunk.js";
};